import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import MenuItems from "./MenuItems";
import RSMobileMenu from "./RSMobileMenu";
import TopHeader from "./TopBar";

import normalLogo from "../../../assets/img/logo/Jntuk-white-logo.png";
import darkLogo from "../../../assets/img/logo/Jntuk-logo.png";

import productImg1 from "../../../assets/img/shop/1.jpg";
import productImg2 from "../../../assets/img/shop/2.jpg";
import { imageBaseURL } from "../../../utils/fetchData";
import { JNTUK_PDF_Links } from "../../../utils/api.config";

const Header = (props) => {
  const {
    headerClass,
    parentMenu,
    secondParentMenu,
    activeMenu,
    headerNormalLogo,
    headerStickyLogo,
    mobileNormalLogo,
    mobileStickyLogo,
    TopBar,
    TopBarClass,
    emailAddress,
    phoneNumber,
    Location,
    CanvasLogo,
    CanvasClass,
  } = props;
  const [menuOpen, setMenuOpen] = useState(false);

  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    // Sticky is displayed after scrolling for 100 pixels
    const toggleVisibility = () => {
      if (window.pageYOffset > 100) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);

    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const searchModalAdd = () => {
    document.body.classList.add("modal-open");
  };

  const canvasMenuAdd = () => {
    document.body.classList.add("nav-expanded");
  };

  const externalLink = (url) => {
    const userConfirmed = window.confirm(
      "You are being redirected to an external website. Please note that JNTUK Portal is not responsible for external websites content & privacy policies."
    );

    if (userConfirmed) {
      window.open(url, "_blank");
    } else {

    }
  };
  const subDomain = (url) => {
    const userConfirmed = window.confirm(
      "You are being redirected to an internal sub-domain website. The sub-domain website will open in a New Tab"
    );

    if (userConfirmed) {
      window.open(url, "_blank");
    } else {

    }
  };

  return (
    <React.Fragment>
      <div
        className={
          headerClass ? headerClass : "full-width-header home8-style4 main-home"
        }
      >
        <header id="rs-header" className="rs-header">
          {TopBar ? (
            <TopHeader
              topBarClass={TopBarClass}
              emailAddress={emailAddress}
              phoneNumber={phoneNumber}
              Location={Location}
            />
          ) : (
            ""
          )}

          <div
            className={
              isVisible ? "menu-area menu-sticky" : "menu-area menu-sticky"
            }
          >
            <div className="container-fluid">
              <div className="row y-middle">
                <div className="col-xl-2">
                  <div className="logo-area hidden-lg">
                    <Link to={`/${process.env.REACT_APP_SUB_DOMAIN}`}>
                      <img
                        className="normal-logo"
                        src={headerNormalLogo ? headerNormalLogo : normalLogo}
                        alt="JNTUK Logo" title="JNTUK Logo"
                      />
                      <img
                        className="sticky-logo"
                        src={headerStickyLogo ? headerStickyLogo : darkLogo}
                        alt="JNTUK Logo" title="JNTUK Logo"
                      />
                    </Link>
                  </div>
                </div>
                <div className="col-xl-10 text-end">
                  <div className="rs-menu-area">
                    <div className="main-menu">
                      <div className="mobile-menu lg-display-block">
                        <Link to="/" className="mobile-normal-logo">
                          <img
                            className="normal-logo"
                            src={
                              mobileNormalLogo ? mobileNormalLogo : normalLogo
                            }
                            alt="JNTUK Logo" title="JNTUK Logo"
                          />
                        </Link>
                        <Link to="/" className="mobile-sticky-logo">
                          <img
                            src={mobileNormalLogo ? mobileNormalLogo : darkLogo}
                            alt="JNTUK Logo" title="JNTUK Logo"
                          />
                        </Link>
                        <span onClick={searchModalAdd} className="rs-search bold-text mr-20">
                          <i className="far fa-search"></i>
                        </span>
                        <span className="rs-menu-toggle"
                          onClick={() => {
                            setMenuOpen(!menuOpen);
                          }}
                        >
                          <i className="fa fa-bars"></i>
                        </span>
                      </div>
                      <nav className="rs-menu hidden-lg">
                        <ul className="nav-menu">
                          <MenuItems
                            parentMenu={parentMenu}
                            secondParentMenu={secondParentMenu}
                            activeMenu={activeMenu}
                          />
                          <li className="rs-mega-menu menu-item-has-children additional-menus submenuRightAligned">
                            <Link to="#">Information For...</Link>
                            <ul className="mega-menu">
                              <li className="mega-menu-container">
                                <div className="single-megamenu">
                                  <ul className="sub-menu">
                                    <li>
                                      <a href={`${process.env.REACT_APP_JNTUK_BASE_URL}/campus-buildings`} target="_blank">
                                        Campus Building
                                      </a>
                                    </li>
                                    <li>
                                      <a href={`${process.env.REACT_APP_JNTUK_BASE_URL}/convocations`} target="_blank">
                                        Convocations
                                      </a>
                                    </li>
                                    <li>
                                      <a href={`${process.env.REACT_APP_JNTUK_BASE_URL}/category/Latest-Events`} target="_blank">
                                        Latest Events
                                      </a>
                                    </li>
                                    <li>
                                      <a href={`${process.env.REACT_APP_JNTUK_BASE_URL}/jntuk-contacts`} target="_blank">
                                        Contacts
                                      </a>
                                    </li>
                                    <li>
                                      <Link onClick={() => externalLink("https://infyspringboard.onwingspan.com/web/en/page/lex_auth_0136054520526520321")}>
                                        Infosys Springboard
                                      </Link>
                                    </li>
                                    <li>
                                      <Link onClick={() => externalLink("https://lms.jntuk.org")}>
                                        Learning Management System
                                      </Link>
                                    </li>
                                    <li>
                                      <Link onClick={() => externalLink("https://odl.jntuk.org")}>
                                        Open Distance Learning /Online Learning
                                      </Link>
                                    </li>
                                  </ul>
                                </div>
                                <div className="single-megamenu">
                                  <ul className="sub-menu">
                                    <li>
                                      <Link onClick={() => externalLink("https://bcde.online")}>
                                        Board for Community Development through
                                        Education (BCDE)
                                      </Link>
                                    </li>
                                  </ul>
                                  <ul className="sub-menu">

                                    <li>
                                      <Link to="#">JNTUK UNITS</Link>
                                      <ul>
                                        <li>
                                          <a href={`${process.env.REACT_APP_JNTUK_BASE_URL}/profile/sc-st-cell`} target="_blank">
                                            SC & ST Cell
                                          </a>
                                        </li>
                                        <li>
                                          <Link onClick={() => subDomain("http://arc.jntuk.edu.in")}>
                                            Anti Ragging Cell
                                          </Link>
                                        </li>
                                        <li>
                                          <a href={`${imageBaseURL}${JNTUK_PDF_Links.Sexual_Harassment_Committees}`} target="_blank" rel="noopener noreferrer">
                                            Sexual Harassment Committees
                                          </a>
                                        </li>
                                        <li>
                                          <Link onClick={() => externalLink("https://jntuknss.org")}>
                                            NSS Cell
                                          </Link>
                                        </li>
                                        <li>
                                          <Link onClick={() => externalLink("https://jntukiqac.com")}>
                                            IQAC
                                          </Link>
                                        </li>
                                        <li>
                                          <Link onClick={() => externalLink("https://ecosak.org.in")}>Alumni Engagement</Link>
                                        </li>
                                      </ul>
                                    </li>
                                  </ul>
                                </div>
                                <div className="single-megamenu">
                                  <ul className="sub-menu">
                                    <li>
                                      <Link to="#">
                                        IIIP & SKILL DEVELOPMENT
                                      </Link>
                                      <ul>
                                        <li>
                                          <a href={`${imageBaseURL}${JNTUK_PDF_Links.Placements_Graph}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                          >
                                            Placements Graph
                                          </a>
                                        </li>
                                        <li>
                                          <a href={`${imageBaseURL}${JNTUK_PDF_Links.Visits_to_Industry}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                          >
                                            Visits to Industry's
                                          </a>
                                        </li>
                                        <li>
                                          <a href={`${imageBaseURL}${JNTUK_PDF_Links.Lab_Openings}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                          >
                                            Lab Openings
                                          </a>
                                        </li>
                                        <li>
                                          <a href={`${imageBaseURL}${JNTUK_PDF_Links.Skill_Development_Programmes}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                          >
                                            Skill Development Programmes
                                          </a>
                                        </li>
                                      </ul>
                                    </li>
                                  </ul>
                                </div>
                              </li>
                            </ul>
                          </li>
                          <li className="sidebarmenu-search">
                            <Link
                              to="#"
                              onClick={searchModalAdd}
                              className="rs-search"
                              href="#"
                            >
                              <i className="flaticon-search"></i>
                            </Link>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>

          <RSMobileMenu
            menuOpen={menuOpen}
            setMenuOpen={setMenuOpen}
            parentMenu={parentMenu}
            secondParentMenu={secondParentMenu}
          />
          <div
            onClick={() => setMenuOpen(false)}
            className={menuOpen ? "body-overlay show" : "body-overlay"}
          ></div>
        </header>
      </div>
    </React.Fragment>
  );
};

export default Header;
